enum CardProgramStatus {
  ACTIVE = "ACTIVE",
  PENDING = "PENDING",
  PENDING_REVIEW = "PENDING_REVIEW",
  DISCONNECTED = "DISCONNECTED",
  INACTIVE = "INACTIVE",
}

export default CardProgramStatus;
